import { Context } from "@nuxt/types/app";

const DEFAULT_ERROR_MESSAGE = "Terjadi kesalahan. Silakan coba lagi.";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  /**
   * Shows error dialog for public pages (login, register, etc.)
   * User must click OK button to close the dialog
   * @param error - The error object from catch block
   */
  function showErrorDialog(error: unknown): void {
    let message = DEFAULT_ERROR_MESSAGE;
    let errorCode: string | undefined;

    if (error && typeof error === "object" && "message" in error) {
      const errorMessage = (error as { message?: unknown }).message;

      // Handle nested error object: { message: { errorCode, message, ... } }
      if (errorMessage && typeof errorMessage === "object" && "errorCode" in errorMessage) {
        const nestedError = errorMessage as { errorCode?: string; message?: string };
        errorCode = nestedError.errorCode;
        message = nestedError.message || DEFAULT_ERROR_MESSAGE;
      } else {
        // Handle flat error object: { message: "string", errorCode: "string" }
        message = errorMessage as string;
        errorCode = (error as { errorCode?: string }).errorCode;
      }
    }

    context.store.dispatch("app/toggleErrorDialog", {
      message: context.app.$helpers.translateKeyContent(
        "FalconErrorMessage",
        errorCode || message,
        DEFAULT_ERROR_MESSAGE
      ),
    });
  }

  return {
    showErrorDialog,
  };
}

